import React from 'react';
import PropTypes from 'prop-types';

const APIKey = ({ theme, fill, ...props }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.2976 1L12.8928 2.40478M12.8928 2.40478L15 4.51196L12.5416 6.97032L10.4345 4.86315M12.8928 2.40478L10.4345 4.86315M7.54763 7.74998C7.9103 8.10782 8.19861 8.53387 8.39595 9.0036C8.59328 9.47333 8.69576 9.97745 8.69746 10.4869C8.69917 10.9964 8.60008 11.5012 8.40589 11.9723C8.2117 12.4433 7.92626 12.8713 7.56599 13.2315C7.20573 13.5918 6.77776 13.8773 6.30672 14.0714C5.83568 14.2656 5.33088 14.3647 4.82139 14.363C4.3119 14.3613 3.80778 14.2588 3.33805 14.0615C2.86833 13.8642 2.44228 13.5759 2.08443 13.2132C1.38073 12.4846 0.991344 11.5087 1.00015 10.4958C1.00895 9.48293 1.41523 8.514 2.13149 7.79774C2.84775 7.08148 3.81668 6.6752 4.82958 6.6664C5.84249 6.65759 6.81833 7.04698 7.54693 7.75068L7.54763 7.74998ZM7.54763 7.74998L10.4345 4.86315"
      stroke="#6930CA"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

APIKey.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default APIKey;
